import { render, staticRenderFns } from "./OtherTrapezoidsA.vue?vue&type=template&id=7f4e1bfc&scoped=true"
import script from "./OtherTrapezoidsA.vue?vue&type=script&lang=js"
export * from "./OtherTrapezoidsA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e1bfc",
  null
  
)

export default component.exports